<template>
<svg viewBox="0 0 35 34" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-My`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_665db7bd0a__clip0_306_997)"><path d="M18 29C11.6593 29 6.5 23.8407 6.5 17.5C6.5 11.1593 11.6593 6 18 6C24.3407 6 29.5 11.1593 29.5 17.5C29.5 23.8407 24.3407 29 18 29ZM18 9.5372C13.6096 9.5372 10.0372 13.1096 10.0372 17.5C10.0372 21.8904 13.6096 25.4628 18 25.4628C22.3904 25.4628 25.9628 21.8904 25.9628 17.5C25.9628 13.1096 22.3904 9.5372 18 9.5372Z"/><path d="M17.9999 23.9204C15.8832 23.9204 13.9025 22.8772 12.7047 21.1309C12.1515 20.3269 12.3554 19.2252 13.1618 18.672C13.9658 18.1188 15.0675 18.3227 15.6207 19.1291C16.1599 19.9143 17.0506 20.3832 17.9999 20.3832C18.9493 20.3832 19.84 19.9143 20.3792 19.1291C20.9324 18.3227 22.0341 18.1188 22.8381 18.672C23.6445 19.2252 23.8484 20.3269 23.2952 21.1309C22.0974 22.8796 20.1166 23.9204 17.9999 23.9204Z"/></g><defs><clipPath id="svg_665db7bd0a__clip0_306_997"><path transform="translate(6.5 6)" d="M0 0H23V23H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconMy',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
